import React, { FC } from 'react';
import { Button } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { utils, writeFile } from 'xlsx';
import { GuideGroup } from './types';

export const ExcelExport: FC<{ groups: GuideGroup[]; sx?: SxProps<Theme> }> = ({ groups, sx }) => {
  const handleExport = () => exportFile(groups);

  return (
    <Button
      variant="outlined"
      color="inherit"
      size="small"
      sx={sx}
      onClick={handleExport}
      startIcon={<img src="/icons8-microsoft-excel.svg" style={{ width: 20, height: 20 }} alt="" />}
      disabled={groups.length === 0}>
      Eksporter til Excel
    </Button>
  );
};

function exportFile(groups: GuideGroup[]) {
  const headings = ['Nummer', 'Tittel', 'Fagområde', 'Versjon', 'Ansvarlig', 'Publisert dato', 'Status'];

  const data = groups.flatMap((group) =>
    group.migrations.map((migration) => {
      const status = migration?.publishedAt
        ? migration.publishedAsPdfOnly
          ? 'Publisert som PDF'
          : 'Publisert fra CMS'
        : 'Ikke publisert';
      return [
        migration?.docName,
        migration?.title,
        group.mainCategory ?? '',
        migration?.version,
        group.ownerName ?? '',
        migration?.publishedAt ? new Date(migration.publishedAt) : null,
        status,
      ];
    }),
  );

  const sheet = utils.aoa_to_sheet([headings, ...data]);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, sheet, 'Migrering');
  writeFile(workbook, 'migrering-utgatte-anvisninger.xlsx');
}
